/* eslint-disable prefer-destructuring */
import React from 'react';
import getSlug from 'speakingurl';
import { figtree } from '../../Landing/fonts';
import { PlaneIcon } from '../../Landing/ui';

// The table of contents as an itinerary: a single, uniform list of
// numbered "stops" on a journal card with a faint contour texture.
// Subheadings are deliberately not listed (bucketlistly-style) — every
// entry reads the same, and the reading nav's scrollspy shows where you
// are once you're inside a chapter.
const TableOfContents = props => {
  const { headings } = props;

  if (!headings || headings.length < 1) return <></>;

  return (
    <nav
      aria-label="Table of contents"
      className={`${figtree.className} tw-relative tw-my-10 tw-overflow-hidden tw-rounded-2xl tw-border tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-width:1.5px] tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] tw-px-6 tw-py-5 sm:tw-px-7 sm:tw-py-6`}
    >
      {/* Faint contour texture, echoing the article header */}
      <svg
        aria-hidden="true"
        className="tw-pointer-events-none tw-absolute tw-inset-0 tw-h-full tw-w-full tw-text-[#1D2D28] tw-opacity-[0.05] dark:tw-text-[#EBE6D9]"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 800 400"
      >
        <g fill="none" stroke="currentColor" strokeWidth="1.2">
          <path d="M-40 60c120-45 240 35 360-5s215-60 360-15 160 55 160 55" />
          <path d="M-40 105c120-45 240 35 360-5s215-60 360-15 160 55 160 55" />
          <path d="M-40 330c135-60 255 45 375 0s200-75 345-20 160 60 160 60" />
        </g>
      </svg>

      <div className="tw-relative">
        <div className="tw-mb-4 tw-flex tw-items-center tw-gap-2">
          <PlaneIcon className="tw-h-3.5 tw-w-3.5 tw-rotate-90 tw-text-primary-600/70 dark:tw-text-primary-300/70" />
          <span className="tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-primary-700 dark:tw-text-primary-300">
            In this story · {headings.length}{' '}
            {headings.length === 1 ? 'stop' : 'stops'}
          </span>
          <span className="tw-h-px tw-flex-1 tw-border-0 tw-border-t tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44]" />
        </div>
        <ol
          className={`toc-list tw-m-0 tw-list-none tw-p-0 tw-gap-x-10 ${
            headings.length > 4 ? 'sm:tw-columns-2' : ''
          }`}
        >
          {headings.map((heading, i) => (
            <li key={heading.title} className="tw-break-inside-avoid">
              <a
                href={`#${getSlug(heading.title)}`}
                className="tw-group tw-flex tw-items-baseline tw-gap-2.5 tw-rounded-md tw-px-1.5 tw-py-1.5 tw-no-underline tw-transition-colors hover:tw-bg-primary-600/[0.06] dark:hover:tw-bg-primary-300/10"
              >
                <span className="tw-w-6 tw-shrink-0 tw-text-right tw-font-mono tw-text-[11px] tw-font-semibold tw-tracking-wide tw-text-primary-600/80 dark:tw-text-primary-300/80">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="tw-text-[15px] tw-font-semibold tw-leading-snug tw-text-[#2A3A34] dark:tw-text-[#D5DDD6] tw-transition-colors group-hover:tw-text-primary-700 dark:group-hover:tw-text-primary-300">
                  {heading.title}
                </span>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default TableOfContents;
